export enum LeadQuotationTypeEnum {
  Car = 'CAR',
  Home = 'HOME',
  Travel = 'TRAVEL',
}
